module.exports = __webpack_public_path__ + "img/header-engagementRingsCordial@2x.3a88ce2.jpg";